import React, { SVGProps, forwardRef } from "react";
import { ReactComponent as DownIcon } from "../../img/Down.svg";
import "./NetworkDropdown.css";
import { NetworkButtonStyled } from "./elements/NetworkButtonStyled";
import { GlobalStore } from "../../store/global/GlobalStore";
import { NETWORK_NAME_TO_DISPLAY } from "../../config/consts";

export interface NetworkButtonProps {
  backgroundColor: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  id: number;
  onClick?: () => void;
  isDropdownOpen: boolean;
}

export const NetworkButton = forwardRef<
  HTMLButtonElement,
  React.PropsWithChildren<NetworkButtonProps>
>((props, ref) => {
  const Icon = props.icon;
  const theme = GlobalStore.useState(s => s.theme);
  const networkName = NETWORK_NAME_TO_DISPLAY[props.id];
  return (
    <>
      <NetworkButtonStyled
        theme={theme}
        isDropdownOpen={props.isDropdownOpen}
        data-testid={"network-button"}
        onClick={props.onClick}
        ref={ref}
      >
        <Icon width={22} height={22} color={props.backgroundColor} />
        {networkName}
        <DownIcon width={20} height={20} stroke={"white"} />
      </NetworkButtonStyled>
      <div>{props.children}</div>
    </>
  );
});
